import { getEnglishComparePageBySlug } from "@/app/seo-compare-en";
import { CompareLayoutEn } from "./CompareLayoutEn";

export default function EnglishHotlineVsApi() {
  const page = getEnglishComparePageBySlug("hotline-vs-api");
  if (!page) return null;
  return <CompareLayoutEn page={page} />;
}
